// @flow
import React, { Fragment, useEffect, useCallback } from 'react';
import { Container, Button } from 'semantic-ui-react';
import { errorLogger } from '../../helpers';
import Loading, { SadFaceSvg, Footer } from 'components';
import * as cssTele2 from './ErrorTele2.module.css';
import * as cssComviq from './ErrorComviq.module.css';
import Header from 'views/Header';
import ReactGA from 'react-ga';
import { useSelector } from 'react-redux';
import { isAppleDevice, isComviqCustomer } from '../../helpers/customerTypeHelpers';
import supportContactDetails from 'assets/content/customerSupportContactDetails.json';
import { CustomerTypes } from '../../Constants';

type Props = {
  message?: string,
};

const Error = ({ message = '' }: Props) => {
  const customerType = useSelector((state) => state.app.customerType);
  const isComviq = isComviqCustomer(customerType);
  const loading = useSelector((state) => state.app.isLoading);

  const css = isComviq ? cssComviq : cssTele2;
  const buttonClasses = isComviq ? `${css.button}` : ``;
  const supportPhoneNumber = supportContactDetails.phoneNumber[String(customerType)];
  const customerServicePhoneNumberString =
    customerType && customerType !== CustomerTypes.MELODY ? ` på telefon ${supportPhoneNumber}` : '';

  const completeSubscription = useCallback(() => {
    /*eslint-disable no-undef*/
    DataActivationController.doneSelected();
  }, []);

  const triggerTel = (number) => {
    infoLogger({ name: 'client-error-trigger-tel', log: 'Customer triggered call to customer service button' });
    window.location = `tel:${number}`;
  };

  useEffect(() => {
    ReactGA.pageview('/error');
    ReactGA.event({
      category: 'Error',
      action: message,
      nonInteraction: true,
    });

    window.__PAGE__ = 'Error';
    errorLogger({
      name: 'client-page-view-error',
      log: `Error component shown with error: Felmeddelande: ${message}`,
    });
  }, []);

  if (loading) return <Loading />;

  return (
    <Fragment>
      <Header />
      <Container className={css.container} as="main">
        {isComviq && <SadFaceSvg />}
        <h1 className={css.title}>Något gick fel</h1>
        <p className={css.text}>
          {`Ditt telefonnummer kunde inte överföras till denna iPhone. Du kan fortsätta konfigurera denna iPhone och försöka överföra ditt telefonnummer igen i mobilinställningarna om en stund eller kontakta kundtjänst.`}
        </p>
        {message && (
          <p className={css.message}>
            Felmeddelande: <span className={css.code}>{message}</span>
          </p>
        )}
        <Footer className={css.footer} isComviq={isComviq}>
          {isAppleDevice() ? (
            <Button color="blue" className={buttonClasses} primary fluid onClick={completeSubscription}>
              Stäng
            </Button>
          ) : (
            <Button
              color="black"
              className={buttonClasses}
              primary
              fluid
              onClick={() => triggerTel(supportPhoneNumber.replace(/-\s/g, ''))}
            >
              Kontakta Kundservice
            </Button>
          )}
        </Footer>
      </Container>
    </Fragment>
  );
};

export default Error;
